import type { StaticSharedField } from './types';
import type { VehicleType } from '/index';
import {
  ERR_TYPE_ENUM_IS_DROPDOWN,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_DROPDOWN,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useVehicleType(vehicleTypesList: VehicleType | undefined): StaticSharedField {
  return {
    propName: 'vehicle_type',
    element: 'vehicle_type',
    type: FIELD_TYPE_DROPDOWN,
    label: 'Vehicle type:',
    values: [
      { name: null, displayName: 'Select a vehicle type' },
      ...(vehicleTypesList?.items ?? []).map((val) => {
        let tChanged = val.title;
        if (val.name?.includes('car')) {
          tChanged = 'Cars';
        } else if (val.name?.includes('van')) {
          tChanged = 'Vans';
        } else if (val.name?.includes('hgv')) {
          tChanged = 'Trucks';
        }
        return {
          name: val.name,
          displayName: tChanged,
        };
      }),
    ],
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOVEHICLETYPE',
        errStr: 'Please select a vehicle type',
      },
      {
        rule: ERR_TYPE_ENUM_IS_DROPDOWN,
        errCode: 'ERRVEHICLETYPENOTFOUND',
        errStr: 'Vehicle type not found',
      },
    ],
  };
}
